module.exports = __webpack_public_path__ + "static/media/fullscreen.ffb9a396.svg";